import { EAccountPlansType } from "../../Enum/EAccountPlansType"

export class AdminCreatePlan {
  eAccountPlansType: EAccountPlansType

  name: string

  description?: string

  displayOrder: number

  constructor(data: Partial<AdminCreatePlan> = {}) {
    this.eAccountPlansType = data.eAccountPlansType ?? EAccountPlansType.None

    this.name = data.name ?? ""

    this.description = data.description

    this.displayOrder = data.displayOrder ?? 0
  }
}
